import * as yup from 'yup';

// yup.setLocale({
//   mixed: {
//     required: 'Required Field',
//   },
// });

export const stringSchema = yup.string().nullable();

export const nonEmptyStringSchema = yup.string();

export const idSchema = yup.string();

export const nullableIdSchema = yup.string().nullable();

export const authIdSchema = yup.string();

export const dateSchema = yup.date();

export const numberSchema = yup.number().nullable();

export const integerSchema = yup
  .number()
  .integer()
  .nullable();

export const emailSchema = yup.string().email();

export const idArraySchema = yup.array().of(idSchema);

export const booleanSchema = yup.boolean().strict();
